'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import lottie from 'lottie-web';
import gsap from 'gsap'
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);

let page

class Page
{
    constructor(view='')
    {
      this.DOM = {
        view:view,
        receptorAnim: view.querySelector('.jsReceptor')
      }
      this.classView = 'currentView--single'
      // Launch Fn
      this.funcLaunch = this.intro.bind(this)
      if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
              setTimeout(() => {
                this.intro()
              }, 500);

            }
            const url = this.DOM.view.querySelector('.jsData').getAttribute('data-json')
            this.instanceAnim = lottie.loadAnimation({
              container: this.DOM.receptorAnim, // the dom element that will contain the animation
              renderer: 'svg',
              loop: true,
              autoplay: false,
              path: url // the path to the animation json
            });
        }, 200);
    }

    intro()
    {
      const DOM = {
        title:this.DOM.view.querySelector('.fxTitle'),
        separator:this.DOM.view.querySelector('.fxSeparator'),
        desc:this.DOM.view.querySelector('.fxDesc'),
      }
      const FX = {}
      FX.titleChildren = new SplitText(DOM.title, { type:'lines' })
      FX.titleParent = new SplitText(DOM.title, { type:'lines' , linesClass:'tw-overflow-hidden' })
      const tl = gsap.timeline()

      tl.add(()=>{
        gsap.set(DOM.title, { autoAlpha:1 })
      })
      tl.add([
        gsap.fromTo(
          FX.titleChildren.lines,
          {
            y:'100%'
          },
          {
            y:'0%',
            ease:'quint.out',
            duration:1,
            stagger:.1
          }
        ),
        gsap.fromTo(
          DOM.separator,
          {
            scaleX:0,
            transformOrigin:'left center'
          },
          {
            scaleX:1,
            duration:2,
            ease:'quint.inOut',
            onStart:()=>{
              gsap.to(this.DOM.receptorAnim, { autoAlpha: 1,duration:.5, ease:'cubic.out' })
              this.instanceAnim.play()
              Env.framework.UI.smoothScrollRefresh()
            }
          }
        ),
        gsap.fromTo(
          DOM.desc,
          {
            autoAlpha:0,
          },
          {
            autoAlpha:1,
            ease:'cubic.out',
            duration:2,
            delay:.5
          }
        ),
      ])
    }
}

page = Barba.BaseView.extend({
    namespace: 'single',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;
